const t = "模态窗口", e = "关闭", o = {
  title: t,
  close: e
};
export {
  e as close,
  o as default,
  t as title
};
